import React, { useState } from 'react';
import { Link, useParams, useNavigate, useSearchParams } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import { listings } from 'src/data/listings';

const isValidUrl = (url) => /^[a-z][a-z0-9+.-]*:/.test(url);

function InnerPage() {
    const { category, slug } = useParams();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const query = searchParams.toString();
    const [imgError, setImgError] = useState(false);

    const listing = listings[category];
    const item = listing?.items.find((i) => i.id === slug || i.slug === slug || i.slug === `/${category}/${slug}`);
    const src = item ? item.banner || item.thumbnail : '';

    if (!listing || !item) return null;

    const descriptionStyles = `.description-body p { padding-bottom: 1.25rem; }`;

    return (
        <div className="site-page max-w-[1920px] w-full mx-auto">
            <style>{descriptionStyles}</style>
            <section className="relative bg-white pt-[5rem] md:pb-8 min-h-[calc(100vh-72px)]">
                <div className="max-w-[1280px] w-full mx-auto px-5 flex flex-col items-start">
                    <button onClick={() => navigate(listing.skipListing ? '/' : `/${category}${query ? `?${query}` : ''}`)} className='flex items-center mt-10 w-fit'>
                        <svg width="10" height="26" viewBox="0 0 15 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M14.2678 0.761522C15.2441 1.77689 15.2441 3.42311 14.2678 4.43848L6.03553 13L14.2678 21.5615C15.2441 22.5769 15.2441 24.2231 14.2678 25.2385C13.2915 26.2538 11.7085 26.2538 10.7322 25.2385L0.732233 14.8385C-0.244078 13.8231 -0.244078 12.1769 0.732233 11.1615L10.7322 0.761522C11.7085 -0.253841 13.2915 -0.253841 14.2678 0.761522Z" fill="black" />
                        </svg>
                        <div className="sm:text-xl text-lg font-bold ml-3">BACK</div>
                    </button>
                    <h3 className="sm:text-3xl text-xl text-[#b81618] font-bold sm:mb-5 mb-2 xs:mt-0 mt-5">
                        {listing.title}
                    </h3>
                    <h1 className="sm:text-4xl text-2xl font-medium mb-2">
                        {item.title}
                    </h1>
                    {item.subtitle && (
                        <h4 className="sm:text-xl text-lg font-medium mb-5">
                            {ReactHtmlParser(item.subtitle)}
                        </h4>
                    )}
                    <div className="w-full max-w-3xl h-64 md:h-96 bg-[#F5F5F5] mx-auto mb-8 overflow-hidden">
                        {src && !imgError ? (
                            <img
                                src={src}
                                alt={item.title}
                                loading="lazy"
                                onError={() => setImgError(true)}
                                className="w-full h-full object-cover object-top"
                            />
                        ) : (
                            <div className="w-full h-full flex items-center justify-center text-4xl font-bold text-[#b81618]">JLR</div>
                        )}
                    </div>
                    {item.description && (
                        <div
                            className="description-body sm:text-base text-sm text-[#6b7076] mb-5 max-w-[1280px]"
                            dangerouslySetInnerHTML={{ __html: item.description }}
                        />
                    )}
                    {item.locations?.length > 0 && (
                        <div className="w-full max-w-[1280px] mb-5">
                            <b className="sm:text-base text-sm text-[#6b7076]">Business Hubs:</b>
                            <div className="flex flex-col gap-4 mt-4">
                                {item.locations.map((loc) => (
                                    <div key={loc.location} className="sm:text-sm text-xs text-[#6b7076]">
                                        <span className="block font-bold">{loc.location}</span>
                                        {loc.address}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                    {(item.url || item.cta?.url) && (
                        <div className="w-full flex justify-end mt-6 md:pb-12">
                            {isValidUrl(item.cta?.url || item.url) ? (
                                <a
                                    href={item.cta?.url || item.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-flex items-center px-6 py-3 border border-black rounded-2xl text-black hover:bg-black hover:text-white transition duration-200"
                                >
                                    {item.cta?.label || 'View Full Article'}
                                    <svg className="w-4 h-4 ml-2" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M13.1716 12L8.22183 7.05025L9.63604 5.63604L16 12L9.63604 18.364L8.22183 16.9497L13.1716 12Z" />
                                    </svg>
                                </a>
                            ) : (
                                <Link
                                    to={item.cta?.url || item.url}
                                    className="inline-flex items-center px-6 py-3 border border-black rounded-2xl text-black hover:bg-black hover:text-white transition duration-200"
                                >
                                    {item.cta?.label || 'View Full Article'}
                                    <svg className="w-4 h-4 ml-2" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M13.1716 12L8.22183 7.05025L9.63604 5.63604L16 12L9.63604 18.364L8.22183 16.9497L13.1716 12Z" />
                                    </svg>
                                </Link>
                            )}
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
}

export default InnerPage;
